'use client';

import { useParams } from 'next/navigation';

import { IIconType } from '@/src/types';
import { InputSearchFaqInput } from '@/src/components/input-search-faq/InputSearchFaqInput';
import { useInputSearchFaq } from '@/src/components/input-search-faq/useInputSearchFaq';
import { InputSearchFaqCard } from '@/src/components/input-search-faq/InputSearchFaqCard';
import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';

type IInputSearchProps = {
  faq?: IResolvedFaqCategory[];
  placeholder: string | null;
  icon: IIconType | null;
};

export const InputSearchFaq = ({
  placeholder,
  icon,
  faq,
}: IInputSearchProps) => {
  const { search, setSearch, faqMemoized, focus, handleFocus, handleBlur } =
    useInputSearchFaq(faq);
  const { locale } = useParams();

  return (
    <div className={'relative md:w-[840px]'}>
      <InputSearchFaqInput
        search={search}
        setSearch={setSearch}
        placeholder={placeholder}
        icon={icon}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {faqMemoized && faqMemoized.length > 0 && (
        <InputSearchFaqCard
          faq={faqMemoized}
          hide={!focus}
          locale={locale as string}
        />
      )}
    </div>
  );
};
